<template>
    <div class="landing-container">
        <div class="container container-top">
            <h1>{{ $t('landing1') }}</h1>
            <h3 class="top1">{{ $t('landing2') }}</h3>
        </div>

        <div class="vlogo"></div>

        <div class="download-container">
            <div class="container">
                <h3 class="top1">{{ $t('landing3') }}</h3>
                <div class="download-btn-wrapper">
                    <a href="https://apps.apple.com/us/app/vindome/id1494570524" target="_blank"
                       class="home-download-ios"></a>
                    <a href="https://play.google.com/store/apps/details?id=com.vindome.wine&hl=en_US&gl=US"
                       target="_blank" class="home-download-android"></a>
                </div>
            </div>
        </div>

        <div class="mobileapp-container people-notice-wrapper" v-if="mobileCheck !== null">
            <div class="contactus-title2">{{ $t('landing4') }}</div>

            <swiper name="HomeSwiper" :options="mobileCheck ? swiperOptionMobile : swiperOption">
                <swiper-slide v-for="(item, index) in swiperData" :key="index">
                    <div v-on:click="showPrivacy(item.article)" class="article-text">
                        <div :class="'testimonial-logo logo-' + item.name"></div>
                        <div class="testimonial-info" v-html="item.value"></div>
                    </div>
                </swiper-slide>
                <div class="swiper-pagination" slot="pagination"></div>
            </swiper>
        </div>

        <div class="download-container2">
            <div class="container">
                <div class="contactus-title2">{{ $t('landing5') }}</div>
                <v-row>
                    <v-col class="col-md-4 right-half-padding">
                        <div class="how-icon why1">
                            <div class="card-icon"></div>
                            <div class="card-text">{{ $t('landing6') }}</div>
                            <div class="card-text2">{{ $t('landing7') }}</div>
                        </div>
                    </v-col>
                    <v-col class="col-md-4 right-half-padding left-half-padding">
                        <div class="how-icon why2">
                            <div class="card-icon"></div>
                            <div class="card-text">{{ $t('landing8') }}<br/>{{ $t('landing8-1') }}</div>
                            <div class="card-text2">{{ $t('landing9') }}</div>
                        </div>
                    </v-col>
                    <v-col class="col-md-4 left-half-padding">
                        <div class="how-icon why3">
                            <div class="card-icon"></div>
                            <div class="card-text">{{ $t('landing10') }}<br/>{{ $t('landing10-1') }}</div>
                            <div class="card-text2">{{ $t('landing11') }}</div>
                        </div>
                    </v-col>
                </v-row>
            </div>
        </div>

        <div class="container">
            <div class="contactus-title2 contactus-title2-better">{{ $t('landing12') }}</div>
            <v-row>
                <v-col class="col-md-4 right-half-padding">
                    <div class="how-icon why4">
                        <div class="card-icon"></div>
                        <div class="card-text">{{ $t('landing13') }}<br/>{{ $t('landing13-1') }}</div>
                        <div class="card-text2">{{ $t('landing14') }}</div>
                    </div>
                </v-col>
                <v-col class="col-md-4 right-half-padding left-half-padding">
                    <div class="how-icon why5">
                        <div class="card-icon"></div>
                        <div class="card-text">{{ $t('landing15') }}</div>
                        <div class="card-text2">{{ $t('landing16') }}</div>
                    </div>
                </v-col>
                <v-col class="col-md-4 left-half-padding">
                    <div class="how-icon why6">
                        <div class="card-icon"></div>
                        <div class="card-text">{{ $t('landing17') }}</div>
                        <div class="card-text2">{{ $t('landing18') }}</div>
                    </div>
                </v-col>
            </v-row>

            <div class="contactus-title2 contactus-title2-better">{{ $t('landing19') }}</div>

            <div class="howto-img-wrapper">
                <div class="how-bullet-item">
                    <div class="how-bullet-item1"></div>
                    <div class="howto-title">{{ $t('landing20') }}</div>
                    <div class="vindome-bullet-subtitle">{{ $t('landing21') }}</div>
                </div>
                <div class="how-bullet-item">
                    <div class="how-bullet-item2"></div>
                    <div class="howto-title">{{ $t('landing22') }}</div>
                    <div class="vindome-bullet-subtitle">{{ $t('landing23') }}</div>
                </div>
            </div>
        </div>

        <div class="download-container3">
            <div class="phone-wrapper">
                <div class="phone-img"></div>
                <div class="phone-text-wrapper">
                    <h3 class="top1">{{ $t('landing3') }}</h3>
                    <div class="download-btn-wrapper">
                        <a href="https://apps.apple.com/us/app/vindome/id1494570524" target="_blank"
                           class="home-download-ios"></a>
                        <a href="https://play.google.com/store/apps/details?id=com.vindome.wine&hl=en_US&gl=US"
                           target="_blank" class="home-download-android"></a>
                    </div>
                </div>
            </div>
        </div>

        <div class="container">
            <div class="contactus-title2 contactus-title2-better">{{ $t('landing26') }}</div>

            <div class="faq-item">
                <div class="faq-item-header">{{ $t('landing27') }}</div>
                <div class="faq-item-text">{{ $t('landing28') }}</div>
            </div>

            <div class="faq-item">
                <div class="faq-item-header">{{ $t('landing29') }}</div>
                <div class="faq-item-text">{{ $t('landing30') }}</div>
            </div>

            <div class="faq-item">
                <div class="faq-item-header">{{ $t('landing31') }}</div>
                <div class="faq-item-text">{{ $t('landing32') }}</div>
            </div>

            <div class="faq-item">
                <div class="faq-item-header">{{ $t('landing33') }}</div>
                <div class="faq-item-text">{{ $t('landing34') }}</div>
            </div>

            <div class="faq-item faq-item-last">
                <div class="faq-item-header">{{ $t('landing35') }}</div>
                <div class="faq-item-text">{{ $t('landing36') }}</div>
            </div>
        </div>

        <v-dialog v-model="showStore" persistent max-width="376px">
            <v-card class="qr-popup">
                <div class="qr-close" v-on:click="hideQR"></div>
                <div class="qr-title">Download the app</div>
                <div :class="{'qr-image': true, 'appStore': appStore, 'googlePlay': googlePlay}"></div>
                <div class="stores">
                    <a v-on:click="() => { storeClick(true) }" href="https://apps.apple.com/app/vindome-wine/id1494570524" target="_blank" class="appstore"
                       v-if="appStore"></a>
                    <a v-on:click="() => { storeClick(false) }" href="https://play.google.com/store/apps/details?id=com.vindome.wine" target="_blank"
                       class="gplay" v-if="googlePlay"></a>
                </div>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import {mapGetters} from "vuex";
import {GCommon} from "@/store/getters";
import {directive, Swiper, SwiperSlide} from "vue-awesome-swiper";
import 'swiper/css/swiper.css'

export default {
    name: "GetTheApp",
    head: {
        title: 'Get the App | Fine Wine Trading App',
        meta: [
            {
                hid: 'description',
                name: 'description',
                content: 'Buy and sell fine wines from your smartphone today! Vindome is the fast, secure and easy way to become a wine trader – right from your smartphone.'
            }
        ],
        bodyAttrs: {
            class: 'page-landing trading-desk'
        }
    },
    components: {
        Swiper,
        SwiperSlide
    },
    directives: {
        swiper: directive
    },
    computed: {
        ...mapGetters({
            mobileCheck: GCommon.GET_MOBILE_VERSION
        })
    },
    data() {
        return {
            showStore: false,
            appStore: false,
            googlePlay: false,
            swiperData: [
                {
                    name: 'dagospia',
                    article: 'dagospia',
                    value: this.$i18n.locale === 'it' ? 'Ma quale Bitcoin! Il vero investimento sicuro è il vino' : 'Forget about Bitcoin! The safest investment these days  is wine ! – “Vindome, the app for trading fine wine” has arrived.'
                },
                {
                    name: 'businessinsider',
                    article: 'BusinessInsider',
                    value: this.$i18n.locale === 'it' ? 'Vindome ha cambiato il mondo degli investimenti in vino pregiato e risolto tutti i problemi annessi a questa tipologia d’investimento' : 'Vindome, the app for investing in the 5.1 billion dollar fine wine market. They have change the approach to fine wine investments and solve all previous issues connected to it, specially for the beginner collector.'
                },
                {
                    name: 'vice',
                    article: 'vice',
                    value: this.$i18n.locale === 'it' ? 'Per decenni, ci sono voluti almeno 10 000 Euro per iniziare. Ora, si stanno aprendo opportunità per i comuni mortali' : 'Come diventare ricchi - o almeno provarci - con il vino'
                }
            ],
            swiperOption: {
                slidesPerView: 3,
                spaceBetween: 60,
                loop: false
            },
            swiperOptionMobile: {
                slidesPerView: 1,
                spaceBetween: 60,
                loop: true,
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true
                },
                autoplay: {
                    delay: 2500,
                    disableOnInteraction: false
                }
            },
        }
    },
    methods: {
        storeClick(isAppStore) {
            this.$gtm.push({ event: isAppStore ? "AppStoreClick" : "GooglePlayClick" });
        },
        showQR(isAppStore) {
            this.showStore = true;
            this.appStore = isAppStore;
            this.googlePlay = !isAppStore;
        },
        hideQR() {
            this.showStore = false;
            this.appStore = false;
            this.googlePlay = false;
        },
        showPrivacy: function (article) {
            if (article === 'dagospia') {
                window.open('https://m.dagospia.com/ma-quale-bitcoin-il-vero-investimento-sicuro-e-il-vinoarriva-vindome-l-app-per-fare-254689');
            } else if (article === 'jamesmagazine') {
                window.open('https://www.jamesmagazine.it/news/vindome-lapp-investe-sui-vini-pregiati/');
            } else if (article === 'vice') {
                window.open('https://www.vice.com/it/article/k7anww/guadagnare-con-il-vino');
            } else {
                window.open(`https://vindome.net/Vindome_${article}.pdf`);
            }
        }
    }
}
</script>

<style scoped>
h1 {
    font-family: Montserrat, sans-serif;
    font-style: normal;
    font-weight: bold;
    font-size: 48.83px;
    line-height: 100%;
    text-align: center;
    color: #303030;
    margin-top: 56px;
    margin-bottom: 32px;
}

h3 {
    font-family: Montserrat, sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 25px;
    line-height: 120%;
    text-align: center;
    color: #303030;
}

h3.top1 {
    max-width: 480px;
    margin: 0 auto;
}

.landing-container {
    background: #ffffff;
    padding-top: 80px;
}

.container {
    max-width: 1170px;
    padding: 0;
    font-family: 'Montserrat', Arial, Helvetica, sans-serif;
}

.container-top {
    background: url('../../assets/how/slide1.png') no-repeat center;
    height: 500px;
}

.vlogo {
    background: url('../../assets/landing/vlogo.png') no-repeat center;
    width: 118px;
    height: 118px;
    margin: 0 auto;
    position: relative;
    z-index: 2;
}

.download-container {
    background: #F6F6F6;
    padding: 86px 0 51px;
    position: relative;
    top: -56px;
}

.download-container2 {
    background: #F6F6F6;
    padding: 62px 0 51px;
}

.download-container3 {
    background: #F6F6F6;
    height: 325px;
}

.phone-wrapper {
    max-width: 866px;
    margin: 0 auto;
    overflow: hidden;
}

.phone-img {
    width: 208px;
    height: 306px;
    margin-top: 19px;
    margin-right: 82px;
    display: inline-block;
    background: url('../../assets/landing/half-phone.png') no-repeat center;
}

.phone-text-wrapper {
    display: inline-block;
    vertical-align: top;
    margin-top: 100px;
}

.phone-text-wrapper h3.top1 {
    text-align: left;
}

.phone-text-wrapper .download-btn-wrapper {
    margin: 40px auto 0;
    text-align: left;
}

.qr-popup.v-card {
    border-radius: 24px;
    height: 421px;
}

.qr-image {
    width: 320px;
    height: 300px;
    margin: 0 auto;
}

.qr-image.appStore {
    background: #ffffff url('../../assets/appstore-qr.svg') no-repeat center;
    background-size: 280px;
}

.qr-image.googlePlay {
    background: #ffffff url('../../assets/gplay-qr.svg') no-repeat center;
    background-size: 280px;
}

.qr-title {
    text-align: center;
    font-size: 22.5px;
    line-height: 31.5px;
    color: #090D0E;
    padding-top: 20px;
}

.qr-close {
    position: absolute;
    z-index: 1;
    top: 16px;
    right: 16px;
    width: 40px;
    height: 40px;
    border-radius: 55%;
    background: #E6C67C url('../../assets/icon-close.svg') no-repeat center;
}

.qr-close:hover {
    background-color: #F1E2C4;
    cursor: pointer;
}

.qr-popup .stores {
    margin: 0;
}

.qr-popup .appstore, .qr-popup .gplay {
    width: 118px;
    height: 38px;
    margin: 0 auto;
    display: block;
}

.home-download-android,
.home-download-ios {
    display: inline-block;
    width: 163px;
    height: 48px;
}

.home-download-ios {
    background: url('../../assets/app/appstore.png') no-repeat center;
    width: 144px;
    margin-right: 16px;
}

.home-download-android {
    background: url('../../assets/app/gplay.png') no-repeat center;
}

.home-download-android:hover,
.home-download-ios:hover {
    cursor: pointer;
}

.download-btn-wrapper {
    margin: 50px auto 0;
    text-align: center;
}

.contactus-title2 {
    font-family: Montserrat, sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 39.06px;
    line-height: 120%;
    text-align: center;
    color: #303030;
    margin-bottom: 60px;
}

.contactus-title2-better {
    max-width: 769px;
    margin: 57px auto 62px;
}

.article-text:hover {
    cursor: pointer;
}

.testimonial-logo {
    width: 161px;
    height: 89px;
    margin: 0 auto 19px;
}

.logo-decanter {
    background: url('../../assets/app/decanter.png') no-repeat center;
}

.logo-winespectator {
    background: url('../../assets/app/winespectator.png') no-repeat center;
}

.logo-saveur {
    background: url('../../assets/app/saveur.png') no-repeat center;
}

.logo-larepubblica {
    background: url('../../assets/app/larepubblica.png') no-repeat center;
    background-size: contain;
}

.logo-ilgiornale {
    background: url('../../assets/app/ilgiornale.png') no-repeat center;
    background-size: contain;
}

.logo-businessinsider {
    background: url('../../assets/app/businessinsider.png') no-repeat center;
    background-size: contain;
}

.logo-cosmopolitan {
    background: url('../../assets/app/cosmopolitan.png') no-repeat center;
    background-size: contain;
}

.logo-digitalclub {
    background: url('../../assets/app/digitalclub.png') no-repeat center;
    background-size: contain;
}

.logo-mixerplanet {
    background: url('../../assets/app/mixerplanet.png') no-repeat center;
    background-size: contain;
}

.logo-igrandivini {
    background: url('../../assets/app/igrandivini.png') no-repeat center;
    background-size: contain;
}

.logo-vanityfair {
    background: url('../../assets/app/vanityfair.svg') no-repeat center;
    background-size: contain;
}

.logo-winenews {
    background: url('../../assets/app/winenews.png') no-repeat center;
    background-size: contain;
}

.logo-dagospia {
    background: url('../../assets/app/dagospia.png') no-repeat center;
    background-size: contain;
}

.logo-vice {
    background: url('../../assets/app/vice.svg') no-repeat center;
    background-size: contain;
}

.logo-jamesmagazine {
    background: url('../../assets/app/jamesmagazine.png') no-repeat center;
    background-size: contain;
}

.testimonial-info {
    font-weight: 400;
    font-size: 25px;
    line-height: 120%;
    text-align: center;
    color: #303030;
}

.mobileapp-container {
    max-width: 1366px;
    margin: 0 auto;
}

.right-half-padding {
    padding-right: 25px
}

.left-half-padding {
    padding-left: 25px
}

.card-icon {
    height: 96px;
    width: 100%;
    margin-bottom: 40px;
}

.why1 .card-icon {
    background: url('../../assets/landing/chart.png') no-repeat center center;
    background-size: contain;
}

.why2 .card-icon {
    background: url('../../assets/landing/check.png') no-repeat center center;
    background-size: contain;
}

.why3 .card-icon {
    background: url('../../assets/landing/glass.png') no-repeat center center;
    background-size: contain;
}

.why4 .card-icon {
    background: url('../../assets/landing/dots.png') no-repeat center center;
    background-size: contain;
}

.why5 .card-icon {
    background: url('../../assets/landing/diamond.png') no-repeat center center;
    background-size: contain;
}

.why6 .card-icon {
    background: url('../../assets/landing/sign.png') no-repeat center center;
    background-size: contain;
}

.card-text {
    font-family: Montserrat, sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 32.83px;
    line-height: 120%;
    text-align: center;
    color: #303030;
    margin-bottom: 16px;
}

.card-text2 {
    font-family: Roboto, sans-serif;
    font-style: normal;
    font-weight: 300;
    font-size: 16px;
    line-height: 160%;
    text-align: center;
    color: #303030;
    max-width: 292px;
    margin: 0 auto;
}

.howto-img-wrapper {
    margin-bottom: 100px;
}

.how-bullet-item {
    display: inline-block;
    width: calc(50% - 39px);
    vertical-align: top;
    position: relative;
}

.how-bullet-item:nth-child(1) {
    margin-right: 39px;
}

.how-bullet-item1 {
    background: url('../../assets/landing/storage2.png') no-repeat center;
    height: 220px;
    width: 100%;
    margin-bottom: 35px;
    background-size: cover;
}

.how-bullet-item2 {
    background: url('../../assets/landing/storage1.png') no-repeat center;
    height: 220px;
    width: 100%;
    margin-bottom: 35px;
    background-size: cover;
}

.how-bullet-item3 {
    background: url('../../assets/landing/storage.png') no-repeat center;
    height: 220px;
    width: 100%;
    margin-bottom: 35px;
    background-size: cover;
}

.how-bullet-item .howto-title {
    font-family: Montserrat, sans-serif;
    font-style: normal;
    font-weight: bold;
    font-size: 25px;
    line-height: 120%;
    color: #303030;
    text-transform: none;
    margin-bottom: 32px;
}

.vindome-bullet-subtitle {
    font-family: Roboto, sans-serif;
    font-style: normal;
    font-weight: 300;
    font-size: 16px;
    line-height: 160%;
    color: #000000;
}

.faq-item {
    max-width: 784px;
    margin: 0 auto;
    padding: 31px 0;
}

.faq-item-last {
    margin-bottom: 52px;
}

.faq-item-header {
    font-family: Montserrat, sans-serif;
    font-style: normal;
    font-weight: bold;
    font-size: 25px;
    line-height: 120%;
    color: #303030;
    margin-bottom: 16px;
}

.faq-item-text {
    font-family: Roboto, sans-serif;
    font-style: normal;
    font-weight: 300;
    font-size: 16px;
    line-height: 160%;
    color: #404040;
    white-space: pre-wrap;
}

@media (max-width: 767px) {
    h1 {
        font-size: 28px;
    }

    h3 {
        font-size: 20px;
    }

    .container {
        padding: 0 12px;
    }

    .container-top {
        background-size: contain;
        height: 420px;
    }

    .card-icon {
        margin-bottom: 10px;
    }

    .download-container2 .row {
        display: block;
    }

    .download-container2 .col {
        width: 100%;
        padding: 0;
        margin: 0 0 60px 0;
    }

    .contactus-title2 {
        font-size: 28px;
        line-height: 30px;
    }

    .testimonial-info {
        padding: 0 15px;
    }

    .howto-img-wrapper {
        padding: 0 15px;
        margin-bottom: 50px;
    }

    .how-bullet-item {
        width: 100%;
        margin-bottom: 30px;
    }

    .how-bullet-item:nth-child(1),
    .how-bullet-item:nth-child(2) {
        margin-right: 0;
    }

    .how-bullet-item .howto-title {
        margin-bottom: 0;
    }

    .vindome-bullet-subtitle {
        margin-bottom: 20px;
    }

    .how-bullet-item1 {
        margin-bottom: 15px;
    }

    .download-container3 {
        height: 500px;
    }

    .phone-img {
        display: block;
        margin: 19px auto 0;
    }

    .phone-text-wrapper {
        margin-top: 22px;
    }

    .phone-text-wrapper h3.top1 {
        text-align: center;
    }

    .phone-text-wrapper .download-btn-wrapper {
        margin: 30px auto 0;
        text-align: center;
    }

    .contactus-title2-better {
        margin: 30px auto;
    }

    .faq-item-header {
        font-size: 20px;
    }
}
</style>
<style>
@media (max-width: 767px) {
    .page-landing .v-application .hidden-md-and-up {
        display: none !important;
    }

    .page-landing .logo img {
        margin: 0 auto !important;
    }
}

.page-landing .logo img {
    margin-top: 17px;
}

.page-landing .lang-nav:hover .submenu {
    right: 0;
}

.swiper-container {
    margin: 0 auto;
    position: relative;
    overflow: hidden;
    list-style: none;
    padding: 0;
    z-index: 1;
    height: 300px;
    width: 100%;
}

.swiper-wrapper {
    position: relative;
    width: 100%;
    height: 100%;
    z-index: 1;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    transition-property: -webkit-transform;
    transition-property: transform;
    transition-property: transform, -webkit-transform;
    box-sizing: content-box;
}

.swiper-container-no-flexbox .swiper-slide {
    float: left
}

.swiper-container-vertical > .swiper-wrapper {
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column
}

.swiper-wrapper {
    position: relative;
    width: 100%;
    height: 100%;
    z-index: 1;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    transition-property: -webkit-transform;
    transition-property: transform;
    transition-property: transform, -webkit-transform;
    box-sizing: content-box
}

.swiper-container-android .swiper-slide, .swiper-wrapper {
    -webkit-transform: translateZ(0);
    transform: translateZ(0)
}

.swiper-container-multirow > .swiper-wrapper {
    -ms-flex-wrap: wrap;
    flex-wrap: wrap
}

.swiper-container-free-mode > .swiper-wrapper {
    transition-timing-function: ease-out;
    margin: 0 auto
}

.swiper-slide {
    -ms-flex-negative: 0;
    flex-shrink: 0;
    width: 100%;
    height: 100%;
    position: relative;
    transition-property: -webkit-transform;
    transition-property: transform;
    transition-property: transform, -webkit-transform
}

.swiper-slide.swiper-slide-active .testimonial-item {
    border-right: 1px solid #F0F0F0;
    padding-left: 0;
    padding-right: 45px;
}

.show-mobile .swiper-slide.swiper-slide-active .testimonial-item {
    border-right: 0;
    padding-right: 0;
}

.swiper-invisible-blank-slide {
    visibility: hidden
}

.swiper-container-autoheight, .swiper-container-autoheight .swiper-slide {
    height: auto
}

.swiper-container-autoheight .swiper-wrapper {
    -webkit-box-align: start;
    -ms-flex-align: start;
    align-items: flex-start;
    transition-property: height, -webkit-transform;
    transition-property: transform, height;
    transition-property: transform, height, -webkit-transform
}

.swiper-container-3d {
    -webkit-perspective: 1200px;
    perspective: 1200px
}

.swiper-container-3d .swiper-cube-shadow, .swiper-container-3d .swiper-slide, .swiper-container-3d .swiper-slide-shadow-bottom, .swiper-container-3d .swiper-slide-shadow-left, .swiper-container-3d .swiper-slide-shadow-right, .swiper-container-3d .swiper-slide-shadow-top, .swiper-container-3d .swiper-wrapper {
    -webkit-transform-style: preserve-3d;
    transform-style: preserve-3d
}

.swiper-container-3d .swiper-slide-shadow-bottom, .swiper-container-3d .swiper-slide-shadow-left, .swiper-container-3d .swiper-slide-shadow-right, .swiper-container-3d .swiper-slide-shadow-top {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    pointer-events: none;
    z-index: 10
}

.swiper-container-3d .swiper-slide-shadow-left {
    background-image: linear-gradient(270deg, rgba(0, 0, 0, .5), transparent)
}

.swiper-container-3d .swiper-slide-shadow-right {
    background-image: linear-gradient(90deg, rgba(0, 0, 0, .5), transparent)
}

.swiper-container-3d .swiper-slide-shadow-top {
    background-image: linear-gradient(0deg, rgba(0, 0, 0, .5), transparent)
}

.swiper-container-3d .swiper-slide-shadow-bottom {
    background-image: linear-gradient(180deg, rgba(0, 0, 0, .5), transparent)
}

.swiper-container-wp8-horizontal, .swiper-container-wp8-horizontal > .swiper-wrapper {
    -ms-touch-action: pan-y;
    touch-action: pan-y
}

.swiper-container-wp8-vertical, .swiper-container-wp8-vertical > .swiper-wrapper {
    -ms-touch-action: pan-x;
    touch-action: pan-x
}

.swiper-button-next, .swiper-button-prev {
    position: absolute;
    top: 50%;
    width: 27px;
    height: 44px;
    margin-top: -22px;
    z-index: 10;
    cursor: pointer;
    background-size: 27px 44px;
    background-position: 50%;
    background-repeat: no-repeat
}

.swiper-button-next.swiper-button-disabled, .swiper-button-prev.swiper-button-disabled {
    opacity: .35;
    cursor: auto;
    pointer-events: none
}

.swiper-button-prev, .swiper-container-rtl .swiper-button-next {
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 27 44'%3E%3Cpath d='M0 22L22 0l2.1 2.1L4.2 22l19.9 19.9L22 44 0 22z' fill='%23007aff'/%3E%3C/svg%3E");
    left: 50px;
    right: auto
}

.swiper-button-next, .swiper-container-rtl .swiper-button-prev {
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 27 44'%3E%3Cpath d='M27 22L5 44l-2.1-2.1L22.8 22 2.9 2.1 5 0l22 22z' fill='%23007aff'/%3E%3C/svg%3E");
    right: 50px;
    left: auto
}

.swiper-button-prev.swiper-button-white, .swiper-container-rtl .swiper-button-next.swiper-button-white {
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 27 44'%3E%3Cpath d='M0 22L22 0l2.1 2.1L4.2 22l19.9 19.9L22 44 0 22z' fill='%23fff'/%3E%3C/svg%3E")
}

.swiper-button-next.swiper-button-white, .swiper-container-rtl .swiper-button-prev.swiper-button-white {
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 27 44'%3E%3Cpath d='M27 22L5 44l-2.1-2.1L22.8 22 2.9 2.1 5 0l22 22z' fill='%23fff'/%3E%3C/svg%3E")
}

.swiper-button-prev.swiper-button-black, .swiper-container-rtl .swiper-button-next.swiper-button-black {
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 27 44'%3E%3Cpath d='M0 22L22 0l2.1 2.1L4.2 22l19.9 19.9L22 44 0 22z'/%3E%3C/svg%3E")
}

.swiper-button-next.swiper-button-black, .swiper-container-rtl .swiper-button-prev.swiper-button-black {
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 27 44'%3E%3Cpath d='M27 22L5 44l-2.1-2.1L22.8 22 2.9 2.1 5 0l22 22z'/%3E%3C/svg%3E")
}

.swiper-pagination {
    position: absolute;
    text-align: center;
    transition: opacity .3s;
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
    z-index: 10
}

.swiper-pagination.swiper-pagination-hidden {
    opacity: 0
}

.swiper-container-horizontal > .swiper-pagination-bullets, .swiper-pagination-custom, .swiper-pagination-fraction {
    bottom: 10px;
    left: 0;
    width: 100%
}

.swiper-pagination-bullets-dynamic {
    overflow: hidden;
    font-size: 0
}

.swiper-pagination-bullets-dynamic .swiper-pagination-bullet {
    -webkit-transform: scale(.33);
    transform: scale(.33);
    position: relative
}

.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active {
    -webkit-transform: scale(1);
    transform: scale(1)
}

.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-prev {
    -webkit-transform: scale(.66);
    transform: scale(.66)
}

.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-prev-prev {
    -webkit-transform: scale(.33);
    transform: scale(.33)
}

.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-next {
    -webkit-transform: scale(.66);
    transform: scale(.66)
}

.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-next-next {
    -webkit-transform: scale(.33);
    transform: scale(.33)
}

.swiper-pagination-bullet {
    width: 8px;
    height: 8px;
    display: inline-block;
    border-radius: 100%;
    background: #000;
    opacity: .2
}

button.swiper-pagination-bullet {
    border: none;
    margin: 0;
    padding: 0;
    box-shadow: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none
}

.swiper-pagination-clickable .swiper-pagination-bullet {
    cursor: pointer
}

.swiper-pagination-bullet-active {
    opacity: 1;
    background: #007aff
}

.swiper-container-vertical > .swiper-pagination-bullets {
    right: 10px;
    top: 50%;
    -webkit-transform: translate3d(0, -50%, 0);
    transform: translate3d(0, -50%, 0)
}

.swiper-container-vertical > .swiper-pagination-bullets .swiper-pagination-bullet {
    margin: 6px 0;
    display: block
}

.swiper-container-vertical > .swiper-pagination-bullets.swiper-pagination-bullets-dynamic {
    top: 50%;
    -webkit-transform: translateY(-50%);
    transform: translateY(-50%);
    width: 8px
}

.swiper-container-vertical > .swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet {
    display: inline-block;
    transition: top .2s, -webkit-transform .2s;
    transition: transform .2s, top .2s;
    transition: transform .2s, top .2s, -webkit-transform .2s
}

.swiper-container-horizontal > .swiper-pagination-bullets .swiper-pagination-bullet {
    margin: 0 4px
}

.swiper-container-horizontal > .swiper-pagination-bullets.swiper-pagination-bullets-dynamic {
    left: 50%;
    -webkit-transform: translateX(-50%);
    transform: translateX(-50%);
    white-space: nowrap
}

.swiper-container-horizontal > .swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet {
    transition: left .2s, -webkit-transform .2s;
    transition: transform .2s, left .2s;
    transition: transform .2s, left .2s, -webkit-transform .2s
}

.swiper-container-horizontal.swiper-container-rtl > .swiper-pagination-bullets-dynamic .swiper-pagination-bullet {
    transition: right .2s, -webkit-transform .2s;
    transition: transform .2s, right .2s;
    transition: transform .2s, right .2s, -webkit-transform .2s
}

.swiper-pagination-progressbar {
    background: rgba(0, 0, 0, .25);
    position: absolute
}

.swiper-pagination-progressbar .swiper-pagination-progressbar-fill {
    background: #007aff;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    -webkit-transform: scale(0);
    transform: scale(0);
    -webkit-transform-origin: left top;
    transform-origin: left top
}

.swiper-container-rtl .swiper-pagination-progressbar .swiper-pagination-progressbar-fill {
    -webkit-transform-origin: right top;
    transform-origin: right top
}

.swiper-container-horizontal > .swiper-pagination-progressbar {
    width: 100%;
    height: 4px;
    left: 0;
    top: 0
}

.swiper-container-vertical > .swiper-pagination-progressbar {
    width: 4px;
    height: 100%;
    left: 0;
    top: 0
}

.swiper-pagination-white .swiper-pagination-bullet-active {
    background: #fff
}

.swiper-pagination-progressbar.swiper-pagination-white {
    background: hsla(0, 0%, 100%, .25)
}

.swiper-pagination-progressbar.swiper-pagination-white .swiper-pagination-progressbar-fill {
    background: #fff
}

.swiper-pagination-black .swiper-pagination-bullet-active {
    background: #000
}

.swiper-pagination-progressbar.swiper-pagination-black {
    background: rgba(0, 0, 0, .25)
}

.swiper-pagination-progressbar.swiper-pagination-black .swiper-pagination-progressbar-fill {
    background: #000
}

.swiper-scrollbar {
    border-radius: 10px;
    position: relative;
    -ms-touch-action: none;
    background: rgba(0, 0, 0, .1)
}

.swiper-container-horizontal > .swiper-scrollbar {
    position: absolute;
    left: 1%;
    bottom: 3px;
    z-index: 50;
    height: 5px;
    width: 98%
}

.swiper-container-vertical > .swiper-scrollbar {
    position: absolute;
    right: 3px;
    top: 1%;
    z-index: 50;
    width: 5px;
    height: 98%
}

.swiper-scrollbar-drag {
    height: 100%;
    width: 100%;
    position: relative;
    background: rgba(0, 0, 0, .5);
    border-radius: 10px;
    left: 0;
    top: 0
}

.swiper-scrollbar-cursor-drag {
    cursor: move
}

.swiper-zoom-container {
    width: 100%;
    height: 100%;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    text-align: center
}

.swiper-zoom-container > canvas, .swiper-zoom-container > img, .swiper-zoom-container > svg {
    max-width: 100%;
    max-height: 100%;
    -o-object-fit: contain;
    object-fit: contain
}

.swiper-slide-zoomed {
    cursor: move
}

.swiper-lazy-preloader {
    width: 42px;
    height: 42px;
    position: absolute;
    left: 50%;
    top: 50%;
    margin-left: -21px;
    margin-top: -21px;
    z-index: 10;
    -webkit-transform-origin: 50%;
    transform-origin: 50%;
    -webkit-animation: swiper-preloader-spin 1s steps(12) infinite;
    animation: swiper-preloader-spin 1s steps(12) infinite
}

.swiper-lazy-preloader:after {
    display: block;
    content: "";
    width: 100%;
    height: 100%;
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg viewBox='0 0 120 120' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Cdefs%3E%3Cpath id='a' stroke='%236c6c6c' stroke-width='11' stroke-linecap='round' d='M60 7v20'/%3E%3C/defs%3E%3Cuse xlink:href='%23a' opacity='.27'/%3E%3Cuse xlink:href='%23a' opacity='.27' transform='rotate(30 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.27' transform='rotate(60 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.27' transform='rotate(90 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.27' transform='rotate(120 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.27' transform='rotate(150 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.37' transform='rotate(180 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.46' transform='rotate(210 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.56' transform='rotate(240 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.66' transform='rotate(270 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.75' transform='rotate(300 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.85' transform='rotate(330 60 60)'/%3E%3C/svg%3E");
    background-position: 50%;
    background-size: 100%;
    background-repeat: no-repeat
}

.swiper-lazy-preloader-white:after {
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg viewBox='0 0 120 120' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Cdefs%3E%3Cpath id='a' stroke='%23fff' stroke-width='11' stroke-linecap='round' d='M60 7v20'/%3E%3C/defs%3E%3Cuse xlink:href='%23a' opacity='.27'/%3E%3Cuse xlink:href='%23a' opacity='.27' transform='rotate(30 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.27' transform='rotate(60 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.27' transform='rotate(90 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.27' transform='rotate(120 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.27' transform='rotate(150 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.37' transform='rotate(180 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.46' transform='rotate(210 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.56' transform='rotate(240 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.66' transform='rotate(270 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.75' transform='rotate(300 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.85' transform='rotate(330 60 60)'/%3E%3C/svg%3E")
}

@-webkit-keyframes swiper-preloader-spin {
    to {
        -webkit-transform: rotate(1turn);
        transform: rotate(1turn)
    }
}

@keyframes swiper-preloader-spin {
    to {
        -webkit-transform: rotate(1turn);
        transform: rotate(1turn)
    }
}

.swiper-container .swiper-notification {
    position: absolute;
    left: 0;
    top: 0;
    pointer-events: none;
    opacity: 0;
    z-index: -1000
}

.swiper-container-fade.swiper-container-free-mode .swiper-slide {
    transition-timing-function: ease-out
}

.swiper-container-fade .swiper-slide {
    pointer-events: none;
    transition-property: opacity
}

.swiper-container-fade .swiper-slide .swiper-slide {
    pointer-events: none
}

.swiper-container-fade .swiper-slide-active, .swiper-container-fade .swiper-slide-active .swiper-slide-active {
    pointer-events: auto
}

.swiper-container-cube {
    overflow: visible
}

.swiper-container-cube .swiper-slide {
    pointer-events: none;
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden;
    z-index: 1;
    visibility: hidden;
    -webkit-transform-origin: 0 0;
    transform-origin: 0 0;
    width: 100%;
    height: 100%
}

.swiper-container-cube .swiper-slide .swiper-slide {
    pointer-events: none
}

.swiper-container-cube.swiper-container-rtl .swiper-slide {
    -webkit-transform-origin: 100% 0;
    transform-origin: 100% 0
}

.swiper-container-cube .swiper-slide-active, .swiper-container-cube .swiper-slide-active .swiper-slide-active {
    pointer-events: auto
}

.swiper-container-cube .swiper-slide-active, .swiper-container-cube .swiper-slide-next, .swiper-container-cube .swiper-slide-next + .swiper-slide, .swiper-container-cube .swiper-slide-prev {
    pointer-events: auto;
    visibility: visible
}

.swiper-container-cube .swiper-slide-shadow-bottom, .swiper-container-cube .swiper-slide-shadow-left, .swiper-container-cube .swiper-slide-shadow-right, .swiper-container-cube .swiper-slide-shadow-top {
    z-index: 0;
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden
}

.swiper-container-cube .swiper-cube-shadow {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    background: #000;
    opacity: .6;
    -webkit-filter: blur(50px);
    filter: blur(50px);
    z-index: 0
}

.swiper-container-flip {
    overflow: visible
}

.swiper-container-flip .swiper-slide {
    pointer-events: none;
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden;
    z-index: 1
}

.swiper-container-flip .swiper-slide .swiper-slide {
    pointer-events: none
}

.swiper-container-flip .swiper-slide-active, .swiper-container-flip .swiper-slide-active .swiper-slide-active {
    pointer-events: auto
}

.swiper-container-flip .swiper-slide-shadow-bottom, .swiper-container-flip .swiper-slide-shadow-left, .swiper-container-flip .swiper-slide-shadow-right, .swiper-container-flip .swiper-slide-shadow-top {
    z-index: 0;
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden
}

.swiper-container-coverflow .swiper-wrapper {
    -ms-perspective: 1200px
}


.page-landing .theme--light.v-application {
    background: #ffffff;
}

.page-landing .header-toolbar {
    box-shadow: none;
}

.page-landing .site-navigation,
.page-landing .notifications-wrapper,
.page-landing .site-navigation-my-account,
.page-landing .header-login-btn {
    display: none;
}

.page-landing .locale-changer .site-navigation {
    display: block;
}

.page-landing .locale-changer {
    position: absolute;
    right: 30px;
    top: 25px;
}

.swiper-container {
    text-align: center;
    height: 325px;
}

.people-notice-wrapper .swiper-container {
    height: 430px;
}

.swiper-pagination-bullet {
    background: #707070;
    opacity: 0.64;
}

.swiper-pagination-bullet-active {
    opacity: 1;
    background: var(--brand);
}

.swiper-button-next:focus,
.swiper-button-prev:focus {
    outline: none;
}

.swiper-button-next {
    background-image: url('../../assets/arrow_next_dark.svg');
}

.swiper-button-prev {
    background-image: url('../../assets/arrow_prev_dark.svg');
}

.swiper-button-next, .swiper-button-prev {
    top: 80px
}
</style>
